import { TraitRegistry, TraitType } from '../../trait-registry';
import { Trait } from '../../trait.type';
import { DieType, DieMaterial } from '../../die.type';
import { clone } from '../../../utils/utils';
import type { DieCreation } from '../../die.type';

export class TamerTrait extends Trait {
  static baseType = TraitType.Tamer;
  static baseTitle = 'Tamer';
  static baseText = 'Gain bite & paw die based on character level.';
  static baseIcon = 'trait';

  type = TamerTrait.baseType;
  title = TamerTrait.baseTitle;
  text = TamerTrait.baseText;
  icon = TamerTrait.baseIcon;

  createDie(type: DieType): DieCreation {
    if (type === DieType.Bite) {
      return { type: DieType.Bite, level: -1, material: DieMaterial.Normal };
    } else {
      return { type: DieType.Paw, level: -1, material: DieMaterial.Normal };
    }
  }

  getDice(): Array<DieCreation> {
    const dice: Array<DieCreation> = [];
    dice.push(this.createDie(DieType.Bite));
    const maxLevelPerDie = 2;

    let levelsToDistribute = this.owner.level;

    while (levelsToDistribute >= 0) {
      //get the last die
      let die = dice[dice.length - 1];

      // If this die is already max level, move to the next die
      if (die.level >= maxLevelPerDie) {
        if (die.type === DieType.Bite) {
          dice.push(this.createDie(DieType.Paw));
        } else {
          dice.push(this.createDie(DieType.Bite));
        }
        die = dice[dice.length - 1];
      }

      die.level += 1;
      levelsToDistribute--;
    }

    return dice;
  }
}

TraitRegistry.register(TamerTrait.baseType, TamerTrait);
